import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { deleteTimestamp } from 'src/utils/common';

import { InventoryState } from '../models/inventoryModel';

const initialState: InventoryState = {
  inventoryId: null,
  product: null,
};

const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setSelectedInventory: (state, action: PayloadAction<InventoryState['inventoryId']>) => {
      state.inventoryId = action.payload;
    },
    setSelectedProduct: (state, action: PayloadAction<InventoryState['product']>) => {
      state.product = action.payload ? deleteTimestamp(action.payload) : null;
    },
  },
});

export const { setSelectedInventory, setSelectedProduct } = inventorySlice.actions;
export default inventorySlice.reducer;
